import React from "react"
import styled, { css } from "styled-components/macro"

interface Props {
  image: "contour" | "city" | "building" | "planet" | "earth"
  degress?: number
  step?: number
  initOpacity?: number
  finalOpacity?: number
  positionX?: string
  positionY?: string
  size?: string
  randomizePosition?: boolean
  repeat: boolean
}

export const ImageMask = (props: Props): JSX.Element => {
  function getPositionX() {
    if (props.positionX) {
      return props.positionX
    } else if (props.randomizePosition) {
      return Math.floor(Math.random() * 1274) + "px"
    } else {
      return 0 + "px"
    }
  }

  function getPositionY() {
    if (props.positionY) {
      return props.positionY
    } else if (props.randomizePosition) {
      return Math.floor(Math.random() * 800) + "px"
    } else {
      return 0 + "px"
    }
  }

  return (
    <S_ImageMask
      image={props.image}
      degress={props.degress ?? 63}
      step={props.step ?? 50}
      finalOpacity={props.finalOpacity ?? 0.5}
      positionX={getPositionX()}
      positionY={getPositionY()}
      size={props.size}
      repeat={props.repeat}
      initOpacity={props.initOpacity}
    />
  )
}

export const S_ImageMask = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  ${props => {
    if (props.image === "contour") {
      return css`
        background: url("/company-contour.png");
      `
    } else if (props.image === "city") {
      return css`
        background: url("/company-city.png");
      `
    } else if (props.image === "building") {
      return css`
        background: url("/company-building.png");
      `
    } else if (props.image === "planet") {
      return css`
        background: url("/company-planet.png");
      `
    } else if (props.image === "earth") {
      return css`
        background: url("/company-earth.jpg");
      `
    }
  }}
  top: 0;
  left: 0;
  ${props => {
    return css`
      background-position: ${props.positionX} ${props.positionY};
      background-repeat: ${props.repeat ? "repeat" : "no-repeat"};
      background-size: ${props.size ?? "auto"};
      -webkit-mask-image: linear-gradient(
        ${props.degress}deg,
        rgba(0, 0, 0, ${props.initOpacity ?? 0}) ${props.step}%,
        rgba(0, 0, 0, ${props.finalOpacity}) 100%
      );
      mask-image: linear-gradient(
        ${props.degress}deg,
        rgba(0, 0, 0, ${props.initOpacity ?? 0}) ${props.step}%,
        rgba(0, 0, 0, ${props.finalOpacity}) 100%
      );
    `
  }}
`
